import { render } from "./Slider1Component.vue?vue&type=template&id=011aa116&scoped=true"
import script from "./Slider1Component.vue?vue&type=script&lang=js"
export * from "./Slider1Component.vue?vue&type=script&lang=js"

import "./Slider1Component.vue?vue&type=style&index=0&id=011aa116&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011aa116"]])

export default __exports__